<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/year-bg.png" />
    <div>
      <div class="list">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">年度BU安徽经营数据</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart07M04 id="global02" :datas="data02" :items="items" :dimensions="dimensions" height="460px" />
      </div>
    </div>
    <NavStyleYear></NavStyleYear>
  </div>
</template>

<script>
  import Echart07M04 from '../../components/Echart07M04.vue'
  import NavStyleYear from '../../components/NavStyleYear.vue'
  
  export default {
    name: 'Year02',
    components: {
      Echart07M04,
      NavStyleYear
    },
    data() {
      return {
        loading: false,
        // items: [],
        // dimensions: ['name', 'firstYear', 'secondYear', 'thirdYear'],
        // data02: []
        items: ['合同额', '确收额', '产品成本', '项目成本', '产品毛利', '项目毛利'],
        dimensions: ['name', 'value1', 'value2', 'value3', 'value4', 'value5', 'value6'],
        data02: [
          // {name: "1月", value1: 6075, value2: 3}, 
          {name: "2月", value1: 10000, value2: 10000, value3: 7000, value4: 400, value5: 70, value6: 74}, 
          {name: "3月", value1: 10001, value2: 10001, value3: 6000, value4: 500, value5: 60, value6: 65}, 
          {name: "4月", value1: 10002, value2: 10002, value3: 6500, value4: 600, value5: 65, value6: 71}, 
          // {name: "5月", value1: 19573, value2: 10}, 
          // {name: "6月", value1: 22588, value2: 11}, 
          // {name: "7月", value1: 18371, value2: 9}, 
          // {name: "8月", value1: 19640, value2: 10}, 
          // {name: "9月", value1: 20405, value2: 10}, 
          // {name: "10月", value1: 20858, value2: 10}, 
          // {name: "11月", value1: 21811, value2: 11}, 
          // {name: "12月", value1: 19412, value2: 10}, 
        ].reverse()
      }
    },
    mounted() {
      // this.$axios.post('/annual_general/findList').then( res => {
      //   this.data02 = res.data.data.slice(0, 6)
      //   let obj = res.data.data[6]
      // this.items = [obj.firstYear, obj.secondYear, obj.thirdYear,]
      // })
    },
    methods: {

    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
  }

  .list {
    padding-bottom: 40px;
  }
  
  .icon-list {
    padding: 0 0 10px;
    display: flex;
    justify-content: center;
    margin: -10px 0 40px;
  }
  .icon {
    width: 40%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(45, 252, 255, .2);
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: rgba(255, 255, 255, .6);
  }
  
  .icon-cur{
    color: white;
    background-color: #1fd6d9;
  }
  
  .title-cont01 {
    margin-bottom: 20px
  }
  .echart-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .echart-box > div {
    width: 50%;
  }
  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
</style>
